
export function Alertfill (props) {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2496_7964)">
                <path d="M17.1541 3.99962L29.8555 25.9996C29.9725 26.2023 30.0341 26.4322 30.0341 26.6663C30.0341 26.9003 29.9725 27.1302 29.8555 27.3329C29.7385 27.5356 29.5702 27.7039 29.3675 27.821C29.1648 27.938 28.9349 27.9996 28.7008 27.9996H3.29814C3.0641 27.9996 2.83418 27.938 2.63149 27.821C2.4288 27.7039 2.26049 27.5356 2.14347 27.3329C2.02645 27.1302 1.96484 26.9003 1.96484 26.6663C1.96485 26.4322 2.02645 26.2023 2.14348 25.9996L14.8448 3.99962C14.9618 3.79694 15.1302 3.62864 15.3328 3.51162C15.5355 3.39461 15.7654 3.33301 15.9995 3.33301C16.2335 3.33301 16.4634 3.39461 16.6661 3.51162C16.8688 3.62864 17.0371 3.79694 17.1541 3.99962ZM14.6661 21.3329V23.9996H17.3328V21.3329H14.6661ZM14.6661 11.9996V18.6663H17.3328V11.9996H14.6661Z"/>
            </g>
        <defs>
            <clipPath id="clip0_2496_7964">
                <rect width="32" height="32" fill="white"/>
            </clipPath>
        </defs>
        </svg>
    )
}